/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_StyleInputs */



/**
* | output |
* | --- |
* | "Style" |
*
* @param {Event_Group_Sync_Property_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_style = /** @type {((inputs?: Event_Group_Sync_Property_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Style")
	if (locale === "it") return /** @type {LocalizedString} */ ("Style")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Style")
	if (locale === "es") return /** @type {LocalizedString} */ ("Style")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Style")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Style")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Style")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Style")
	return /** @type {LocalizedString} */ ("Style")
});